import { env } from '@/lib/env'

/**
 * Inject the Adyen drop-in stylesheet matching the resolved Adyen environment
 * (test for non-production, live for production). Mirrors the webpack-era
 * `src/app/ui/page.tsx::adyenCss` logic — keeping a single hardcoded URL
 * (like the initial Vite rewrite did) causes icon / asset CSP mismatches when
 * Adyen runs against the opposite environment.
 *
 * Pinned to SDK version 6.6.0 in lockstep with `@adyen/adyen-web` in
 * package.json — bump both together. See specs/app/index.md::Decisions
 * 2026-05-11.
 */
const ADYEN_SDK_VERSION = '6.6.0'
const adyenEnvironment = env.ENV === 'production' ? 'live' : 'test'

const link = document.createElement('link')
link.rel = 'stylesheet'
link.href = `https://checkoutshopper-${adyenEnvironment}.adyen.com/checkoutshopper/sdk/${ADYEN_SDK_VERSION}/adyen.css`
document.head.appendChild(link)
